
export const FormatDate = (value) => {
    var date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    return `${y}-${m}-${d}`;
}
export const FormatTime = (value) => {
    if (value === null || value === '') return ''
    var date = new Date(value)
    var year = date.getFullYear()
    var month =
      date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1
    var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var minutes =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var seconds =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return (
      year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
    )
  }
  export const FormatDatec = (value) => {
    var date = new Date(value);
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    let d = date.getDate();
    return `${y}年${m}月${d}日`;
}